import React, { useEffect, useState } from 'react';
import LineChart from '@/pages/home/components/Chart/components/LineChart';
import { xAxisHighLight } from '@/pages/home/components/Chart/_config/plug';
import { sortLineTooltipValue, valueFormat } from '@/pages/home/pages/home/Explore/_config/common';
import moment from 'moment';
import * as echarts from 'echarts';

const handleDataFormat = (value: any, segVal: any) => {
  if (value === '' || value === null || value === '-' || value === undefined) {
    return '-';
  }
  if (value === 0 || value === '0') {
    return 0;
  }
  if (['arpu', 'arppu'].includes(segVal)) {
    return Number(value)?.toFixed(2);
  } if (['d2', 'pay_permeability'].includes(segVal)) {
    return `${Number(value)?.toFixed(2)  }%`;
  } 
  return valueFormat(value);
  
};

export default function ExploreEchart(props: any) {
  const { segVal, chartData, chartName, selectedKeys } = props;
  const [xAxisData, setXAxisData] = useState<string[]>([]);
  const [legendData, setLegendData] = useState<string[]>([]);
  const [legendText, setLegendText] = useState<string[]>([]);
  const [series, setSeries] = useState([]);

  useEffect(() => {
    /** 组装数据格式 */
    const colorArr = ['#376AE7', '#3ECBFF', '#4FCB87', '#FFD14E', '#ED9142', '#E95F6A', '#CF61AC', '#8164CD', '#6A7597', '#468C8A'];
    const _legends: string[] = [];
    const _xAxis: string[] = [];
    const legendText: any = [];
    const _series = chartData?.map((t: any, i: number) => {
      const _data: number[] = [];
      const _name = t.game;// `${t?.game_name_cn}(${t?.game_name_en})`;
      _legends.push(_name);
      legendText.push({
        name: t?.game,
        text: `${t?.game_name_cn}(${t?.game_name_en})`,
        permission: t.has_permission
      });

      t?.data_list?.forEach((d: any) => {
        const time = moment(d?.dtstatdate).format('YYYY-MM-DD');
        if (!_xAxis?.includes(time)) {
          _xAxis.push(time);
        }
        _data.push(d[segVal]);
      });

      // 使用取模运算确保颜色索引在数组范围内
      const colorIndex = i % colorArr?.length;
      const currentColor = colorArr?.[colorIndex];

      return {
        name: t?.game,
        // name: _name,
        type: 'line',
        showSymbol: _data?.length === 1 || _data?.filter((e) => e)?.length === 1, // 只有一个点的时候需要显示圆点
        symbol: 'emptyCircle',
        color: currentColor,
        symbolSize: 8,
        lineStyle: {
          type: 'solid'
        },
        areaStyle: {
          opacity: 0.25,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: currentColor
            },
            {
              offset: 1,
              color: '#FFF'
            },
          ])
        },
        emphasis: {
          focus: 'series'
        },
        data: _data,
      };
    });
    setLegendText(legendText);
    setSeries(_series);
    /** 拿到legend */
    setLegendData(_legends);
    /** 重组时间X轴 */
    setXAxisData(_xAxis);

  }, [segVal, chartName, JSON.stringify(selectedKeys), JSON.stringify(chartData)]);

  const lineFormatterFunc = (params: string | any[], title: any, segVal: string,) => {
    // 折线图数值排序
    const param = sortLineTooltipValue(params, false, chartData);

    try {
      let returnStr = `<div class=${'basic-formatter-box'}>
            <div class=${'basic-formatter-header'}>
            <p class='basic-formatter-one basic-formatter-title'>${param[0].axisValue}</p>
            <p class='basic-formatter-two basic-formatter-title'>${title}</p></div>`;
      for (let i = 0;i < param?.length;i++) {
        const dauValue = handleDataFormat(param[i]?.value, segVal);
        // const name = param[i].seriesName;
        const t: any = legendText?.find((item: any) => {
          return item?.name === param[i].seriesName;
        });
        const name = t?.text;
        returnStr += `<div class=${'basic-formatter-header'}>
            <p class=${'basic-formatter-one'}>
            <span style='display:inline-block;margin-right:4px;border-radius:8px;width:8px;height:8px;background-color:${param[i].color};'></span>
            &nbsp;${name}</p>
            <p class=${'basic-formatter-two'}>${!t?.permission ? '*' : dauValue}</p></div>`;
      }
      returnStr = `${returnStr}`;
      return returnStr;
    } catch (err) {
      return '';
    }
  };

  return (
    <><LineChart
      height={304}
      legendData={legendData}
      xAxisData={xAxisData}
      series={series}
      formatterFunc={(params: any) => lineFormatterFunc(params, chartName, segVal)}
      setOtherConfigFunc={(opt: any) => {
        opt.grid.containLabel = true;
        // opt.legend.type="plain"
        opt = xAxisHighLight(opt, {
        });
        opt.legend.formatter = (value: any) => {
          const t: any = legendText?.find((item: any) => {
            return item?.name === value;
          });
          return t?.text;
        };
        return opt;
      }}
      yAxisFormat={(value: number) => {
        if (['d2', 'pay_permeability'].includes(segVal)) {
          return `${value  }%`;
        }
        if (['arpu', 'arppu'].includes(segVal)) {
          return value;
        }
        return valueFormat(value);
      }}
    /></>
  );
}
